import createAxiosInstance from './axiosConfig';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest');

export interface ParametroCertificadoOperador {
  id?: number;
  tipoCertificado: string;
  descricao?: string;
  ativo?: boolean;
}

export default class ParametroCertificadoOperadorService {
  axios: any;

  constructor() {
    this.axios = axiosInstance;
  }

  async listarTodos() {
    return await this.axios.get('/parametroCertificadoOperadorController/listarTodos');
  }

  async salvar(parametro: ParametroCertificadoOperador) {
    return await this.axios.post('/parametroCertificadoOperadorController/salvar', parametro);
  }

  async excluir(id: number) {
    return await this.axios.get(`/parametroCertificadoOperadorController/excluir?id=${id}`);
  }

  async listarTiposPermitidos() {
    return await this.axios.get('/parametroCertificadoOperadorController/listarTiposPermitidos');
  }

  async sincronizarTipos() {
    return await this.axios.post('/parametroCertificadoOperadorController/sincronizarTipos');
  }
}
